"use client";

import React from "react";
import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Form, FormField, FormItem, FormLabel, FormControl, FormMessage, FormDescription } from "@/components/ui/form";
import { Loader, CircleCheck } from "lucide-react";
export default function RestezInforme() {
  return <section data-section-id="224463" id="join-the-ritual" className="py-20 md:py-32 px-4 sm:px-6 dark bg-background text-foreground">
      <div className="max-w-3xl mx-auto">
        <div className="border border-border/30 rounded-none p-8 md:p-14 bg-card shadow-none text-center relative overflow-hidden">
          {}
          <div className="absolute -top-24 -right-24 w-64 h-64 bg-primary/5 rounded-full blur-3xl pointer-events-none" />
          <div className="absolute -bottom-24 -left-24 w-64 h-64 bg-primary/5 rounded-full blur-3xl pointer-events-none" />

          <div className="relative z-10">
            <h2 className="text-4xl md:text-5xl font-default font-light text-foreground mb-4 tracking-tight">
              Join the Ritual
            </h2>
            <p className="text-muted-foreground mb-12 max-w-lg mx-auto font-sans leading-relaxed">
              Be the first to experience our limited seasonal drops and exclusive botanical insights.
            </p>

            <FormProvider formKey="join_ritual_form_home" formId="join_ritual_form_home" sectionName="RestezInforme" defaultValues={{
            first_name: "",
            email: "",
            consent: false
          }} validationRules={{
            first_name: {
              maxLength: 50
            },
            email: {
              required: true,
              pattern: "email"
            },
            consent: {
              required: true
            }
          }} submitText="Join →" successMessage="Thank you for joining. Our next drop awaits you." className="max-w-md mx-auto text-left">
              <NewsletterForm />
            </FormProvider>
          </div>
        </div>
      </div>
    </section>;
}
function NewsletterForm() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    resetForm,
    control
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <div className="flex flex-col items-center justify-center p-8 text-center space-y-4 animate-in fade-in zoom-in duration-500">
        <div className="size-12 rounded-full bg-primary/10 flex items-center justify-center text-primary mb-2">
          <CircleCheck className="size-6" />
        </div>
        <p className="text-foreground font-default text-xl">{successMessage}</p>
        <Button onClick={resetForm} variant="outline" className="mt-4 rounded-none font-serif tracking-wide border-border/50 hover:bg-secondary">
          Join with another email
        </Button>
      </div>;
  }
  return <Form onSubmit={handleSubmit} className="space-y-6">
      <FormField control={control} name="first_name" render={({
      field
    }) => <FormItem>
            <FormLabel className="sr-only">First Name</FormLabel>
            <FormControl>
              <Input placeholder="First Name (Optional)" className="rounded-none h-12 px-0 bg-transparent border-t-0 border-x-0 border-b border-border/50 focus-visible:border-primary focus-visible:ring-0 shadow-none font-serif text-lg italic placeholder:text-muted-foreground/50 transition-colors" {...field} />
            </FormControl>
            <FormMessage className="px-0" />
          </FormItem>} />

      <FormField control={control} name="email" rules={{
      required: "Email address is required",
      pattern: {
        value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
        message: "Invalid email address"
      }
    }} render={({
      field
    }) => <FormItem>
            <FormLabel className="sr-only">Email Address</FormLabel>
            <FormControl>
              <div className="relative group">
                <Input type="email" placeholder="Email Address" className="rounded-none h-14 pl-0 pr-24 bg-transparent border-t-0 border-x-0 border-b border-border focus-visible:border-primary focus-visible:ring-0 shadow-none font-serif text-xl italic placeholder:text-muted-foreground/50 transition-all" {...field} />
                <Button type="submit" disabled={isSubmitting} className="absolute right-0 top-1 bottom-1 rounded-none h-auto px-0 font-default text-lg bg-transparent text-foreground hover:bg-transparent hover:translate-x-1 transition-all active:scale-95 shadow-none">
                  {isSubmitting ? <Loader className="animate-spin size-5" /> : "Join →"}
                </Button>
              </div>
            </FormControl>
            <FormMessage className="px-0" />
          </FormItem>} />

      <FormField control={control} name="consent" rules={{
      required: "Your consent is required to join"
    }} render={({
      field
    }) => <FormItem className="flex flex-row items-start space-x-3 space-y-0 px-0 mt-8">
            <FormControl>
              <input type="checkbox" className="mt-1 size-4 shrink-0 rounded-none border-border text-primary focus:ring-0 accent-primary cursor-pointer bg-transparent" checked={field.value} onChange={field.onChange} />
            </FormControl>
            <div className="space-y-1.5 leading-none">
              <FormLabel className="text-xs font-normal text-muted-foreground cursor-pointer select-none uppercase tracking-widest">
                I agree to receive updates on drops and rituals.
              </FormLabel>
              <FormDescription className="text-[10px] text-muted-foreground/60 italic font-serif">
                Privacy is sacred. Unsubscribe at any time.
              </FormDescription>
            </div>
          </FormItem>} />

      {submitError && <div className="p-4 mt-4 bg-destructive/5 border border-destructive/20 rounded-none">
          <p className="text-destructive text-xs text-center font-mono tracking-tight">{submitError}</p>
        </div>}
    </Form>;
}